<template>
  <div class="doctorInfo" v-if="$store.state.nowPatientInfo">
<!--    <div class="doctorSelectBox">-->
<!--      <el-select v-model="doctorInfo.doctor" placeholder="医生">-->
<!--        <el-option-->
<!--            v-for="item in doctorList"-->
<!--            :key="item.id"-->
<!--            :label="item.label"-->
<!--            :value="item.label">-->
<!--        </el-option>-->
<!--      </el-select>-->
<!--    </div>-->
    <div class="czNumsBox">
      <el-select v-model="doctorInfo.czNums" placeholder="">
        <el-option label="初诊" :value="1"></el-option>
        <el-option label="复诊" :value="0"></el-option>
      </el-select>
    </div>
<!--    <div class="moneyBox">-->
<!--      <div class="money">￥</div>-->
<!--     <el-input v-model="doctorInfo.money" type="text"/>-->
<!--    </div>-->
<!--    <div class="payTypeBox">-->
<!--      <el-select v-model="doctorInfo.payType" placeholder="">-->
<!--        <el-option label="自费门诊" value="自费门诊"></el-option>-->
<!--        <el-option label="医保普通门诊" value="医保普通门诊"></el-option>-->
<!--        <el-option label="医保慢特病门诊" value="医保慢特病门诊"></el-option>-->
<!--      </el-select>-->
<!--    </div>-->
  </div>
</template>

<script>
import {doctorList} from '@/views/outpatientDoctorWorkstation/outpatientService/staticData.js'
export default {
  name: "index",
  data() {
    return {
      doctorList,
      doctorInfo:{
        doctor: '王鑫月',
        czNums: 1,
        money: '0.00',
        payType: '自费门诊'
      }
    }
  },
  watch: {
    '$store.state.nowPatientInfo':{
      handler (newValue,oldValue) {
        console.log('rrrrrrrrrrrr', newValue)
        let data = this.$store.getters.getNowMedicalRecordDraftByDraftId(newValue)
        console.log(data)
        if (data && data.registerInfo) {
          this.doctorInfo.czNums = data.registerInfo.initialDiagnosis
        } else if (this.$store.state.nowRegisterInfo && this.$store.state.nowRegisterInfo.initialDiagnosis !== undefined) {
          this.doctorInfo.czNums = this.$store.state.nowRegisterInfo.initialDiagnosis
        }

      },
      deep:true,
      immediate:true
    }
    // '$store.state.nowRegisterInfo':{
    //   handler (val) {
    //     console.log('ccccVVVVVVVVVVVccccccccc', val)
    //     this.doctorInfo.czNums = val ? val.initialDiagnosis : 1
    //     if (this.doctorInfo.czNums === undefined) {
    //       this.doctorInfo.czNums = 1
    //     }
    //     console.log('zzzzzzzzz', this.doctorInfo.czNums)
    //   },
    //   deep:true,
    //   immediate: true
    // }
  }
}
</script>

<style lang="less" scoped>
.doctorInfo {
  display: flex;
  align-items: center;
  .doctorSelectBox {
    height: 40px;
    width: 120px;
    border-radius: 5px 0 0 5px;
    border: 1px solid transparent;
    display: flex;
    align-items: center;
    /deep/ .el-input__inner{
      border-radius: 5px 0 0 5px;
      border-right: 1px dashed rgba(0,0,0,.2);
    }
  }
  .czNumsBox {
    height: 40px;
    width:75px;
    //border: 1px solid transparent;
    display: flex;
    align-items: center;
    position: relative;
    right: 20px;
    /deep/ .el-input__inner{
      border-radius: 4px;
      //border-left: none;
      //border-right: 1px dashed rgba(0,0,0,.2);
    }
  }
  .moneyBox{
    height: 40px;
    width:80px;
    border: 1px solid transparent;
    display: flex;
    align-items: center;
    position: relative;
    right: 3px;
    .money{
      position: absolute;
      z-index: 1;
      left: 4px;
      top: 8px;
    }
    /deep/ .el-input__inner{
      border-radius: 0;
      border-left: none;
      border-right: 1px dashed rgba(0,0,0,.2);
      padding-left: 20px;
    }
  }
  .payTypeBox{
    height: 40px;
    width: 150px;
    border-radius: 0 5px 5px 0;
    border: 1px solid transparent;
    display: flex;
    align-items: center;
    position: relative;
    right: 5px;
    /deep/ .el-input__inner{
      border-radius: 0 5px 5px 0;
      //border-left: 1px dashed rgba(0,0,0,.2);
    }
  }
}
/deep/ .el-input__inner{
  height: 40px;
  color: #000;
  &:focus {
    border-color: #0270c9 !important;
    box-shadow: 0 0 0 2px #c3e0fe !important;
  }
  &:hover {
    border-color: #0270c9 !important;
  }
}
/deep/ .el-input__icon{
  line-height: 28px;
}
</style>
